export const tip = [
  {
    tip: "Review your monthly budget to confirm that the EMI fits comfortably. If needed, choose a repayment term that aligns with your monthly income to avoid late payments.",
  },
];
